import Button from 'components/atoms/Button';
import Icon from 'components/atoms/Icon';
import { MessageMedia } from 'utils/gloo-types';
import { useState } from 'react';
import { MediaUploadDto } from 'utils/mms';
import { MediaUploadResult } from '../../organisms/CloudinaryMediaUploader';

export interface IMMSImageProps {
  image: MediaUploadResult | MediaUploadDto;
  messageMedia?: MessageMedia;
  deleteImage: (id: string | null) => void;
  isInSideModal?: boolean;
}

const cloudinaryUrlBase = `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_ID || ''}/image/upload`;
const cloudinaryUrl = `${cloudinaryUrlBase}/ar_1:1,c_fill,c_crop,g_custom/w_90,h_90,c_scale/q_90/v1606343627/`;

export const MMSImage = ({ image, messageMedia, deleteImage }: IMMSImageProps) => {
  const containerClass = `h-26 absolute right-5 top-5`;
  const imageSrc = `${cloudinaryUrl}/${messageMedia?.cloudinaryId || image?.info?.public_id || ''}.jpg`;
  const imageActiveClass = ' transition-all border-2 border-primary';
  const [active, setActive] = useState<boolean>(false);
  const imageClass = `rounded-xl h-20 w-20 min-w-20 ${active && imageActiveClass}`;
  const onMouseEnter = () => setActive(true);
  const onMouseLeave = () => setActive(false);

  return (
    <div className={containerClass} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <Button
        dataDurableId="ImageDeleteButton"
        className="flex justify-center items-center absolute z-10 w-4 h-6 rounded-full bg-primary -top-1 -right-3"
        size="small"
        onClick={() => {
          if (deleteImage) {
            deleteImage(messageMedia?.cloudinaryId || image?.info?.public_id);
          }
        }}
      >
        <Icon
          name="x"
          svgFillClassName="text-white"
          width="20"
          height="20"
          className="pointer-events-none cursor-pointer relative"
        />
      </Button>
      <img alt="MMS Media Attachment" src={imageSrc} className={imageClass} />
    </div>
  );
};
